import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage, makeDataDangerous} from 'nutshell-core/utils/graphql-errors';

import type {
    GetWebsiteTrafficDashboard_websiteTrafficDashboard as WebsiteTrafficDashboard,
    GetWebsiteTrafficDashboard as GetWebsiteTrafficDashboardQuery,
    GetWebsiteTrafficDashboardVariables as GetWebsiteTrafficDashboardQueryVariables,
    DashboardInput,
} from 'nutshell-graphql-types';

import GET_EDITIONS_DASHBOARD from '../queries/get-website-traffic-dashboard.graphql';

export const useGetWebsiteTrafficDashboard = (
    input: DashboardInput
): {
    isLoading: boolean;
    errorMessage: string | null | undefined;
    websiteTrafficDashboard: WebsiteTrafficDashboard;
} => {
    const {loading, data, error} = useQuery<
        GetWebsiteTrafficDashboardQuery,
        GetWebsiteTrafficDashboardQueryVariables
    >(GET_EDITIONS_DASHBOARD, {
        variables: {input},
        notifyOnNetworkStatusChange: true,
    });

    const {websiteTrafficDashboard} = makeDataDangerous(data);

    return {
        isLoading: loading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        websiteTrafficDashboard,
    };
};
